<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :queryOnLoad="true" :configAuto="configAuto" :onConfigReady="onConfigReady" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import servcApi from '../../api/servc'

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbAuthOutMsuSave from './AuthOutMsuSave';
    Vue.regist(SwbAuthOutMsuSave);

    import SwbAuthOutMsuUpdate from './AuthOutMsuUpdate';
    Vue.regist(SwbAuthOutMsuUpdate);

    import SwbAccAndBasicClaimInfo from '../servcClaim/AccAndBasicClaimInfo';
    Vue.regist(SwbAccAndBasicClaimInfo);

    export default {
        name: 'swb-auth-out-msu-list-for-select',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '授权出去的服务选择列表',
        props: {
            selectDisabled: {
                type: Boolean,
                default: false
            },
            checkBox: {
                type: Boolean,
                default: false
            },
            selectIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                confKey: 'swb-auth-out-msu-list',
                configAuto: true,
                tableHeight: '500',
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                selectTab: true,
                shopFlag: false,
                //排序、搜索
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                servcTypeMap: getEnumMap('servcType', 'value2text')
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.multiSelect = this.checkBox;
            this.multiPageSelect = this.checkBox;
        },
        mounted() {
            //
            this.initResultTable();
            //回显数据处理
            let initChecked = this.selectIds;
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(initChecked, this.selectDisabled);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let servcTypes = getEnumList("servcType");
                let dataList = [{
                    value: null,
                    label: '- 全部 -'
                }];
                for(let i = 0; i < servcTypes.length; i++) {
                    let item = servcTypes[i];
                    let queryItem = {};
                    queryItem.value = item.value;
                    queryItem.label = item.text;
                    dataList.push(queryItem);
                }
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {
                    dataList: dataList
                };
                let fieldInfo = {};
                fieldInfo["type"] = data;
                query_model_ctrl.updateFields(fieldInfo);
            },
            //
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);    // .getResultColConfRef()
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'authState': function (row, colName, colValue, rowIndex, colConf) {
                        if(new Date(row.distDateTo).format('yyyy-MM-dd') < new Date().format('yyyy-MM-dd')) {
                            return '<span class="font-red">已过期</span> ';
                        } else {
                            if(row.accepted) {
                                return '<span class="font-green">已接受</span> ';
                            } else {
                                return '<span>未接受</span> ';
                            }
                        }
                    },
                    'type': function (row, colName, colValue, rowIndex, colConf) {
                        //
                        return '<span>' + self.servcTypeMap[row.type] + '</span> ';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            popupHandler: function (fieldCode, curValue, curText) {
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //缓存查询条件
                this.getSsuList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getSsuList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getSsuList();
            },
            //
            getSsuList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItem = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let filterItems = Object.assign(filterItem, self.filter);
                //
                let authState = filterItems.authState;
                if(authState == 1) {
                    filterItems.accepted = false;
                } else if(authState == 2) {
                    filterItems.accepted = true;
                } else if(authState == 3) {
                    // 已过期
                    filterItems.authInvalid = true;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                servcApi.getAuthOutMsuPagedList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let msuList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.renderTable(msuList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection() || [];
                //
                let result = {};
                if(selectList.length <= 0) {
                    result.type = "warn";
                    if(Utils.isTrue(this.checkBox)) {
                        result.message = "请至少选择一个服务！";
                    } else {
                        result.message = "请选择服务！";
                    }
                } else {
                    result.type = "info";
                    result.data = selectList;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servc/AuthOutMsuListForSelect.vue